import React from "react";
import clsx from "clsx";
import { Box, Icons, Tooltip } from '@curves/ui-base';


import { isEqual, isFunction} from '@Util/utils';
const EditableInfo = ({ className, onEdit, label, children, isMultiline }) => {
    const isEdit = isFunction(onEdit);
    const handleClick = () => {
        isEdit && onEdit();
    };
    return (
        <Box
            className={clsx("editable-info", isMultiline && "editable-info-multiline", isEdit && "editable-info-edit", className)}
            onClick={handleClick}>
            <Box className="editable-info-title">{label}</Box>
            {isEqual(children, "string") ? (
                <Tooltip title={children}>
                    <Box className="editable-info-content">{children}</Box>
                </Tooltip>
            ) : (
                <Box className="editable-info-content">{children}</Box>
            )}
            {isEdit && <Icons.Edit className={"editable-info-icon"} />}
        </Box>
    );
};
export default EditableInfo;
